import { Box } from '@chakra-ui/react';
import { SOCIAL_PLATFORMS } from '~/constants';
import { MetricsSlider } from '~/screens/MyAgency/components/FiltersDrawer/PerformanceMetrics/MetricsSlider';
import { useAdvancedFiltersStore } from '~/screens/MyAgency/store';
import { FILTERS } from '~/screens/MyAgency/types';

import {
  tiktokAverageEngagementRate,
  tiktokAverageViews,
} from '../FollowerMetricsConstants';

export const TiktokMetrics: React.FC = () => {
  const { getFilter } = useAdvancedFiltersStore();

  return (
    <Box>
      <MetricsSlider
        title="Average Views"
        value={getFilter(SOCIAL_PLATFORMS.tiktok, FILTERS.ttAverageViews) || 0}
        metrics={tiktokAverageViews}
        filterType={FILTERS.ttAverageViews}
      />
      <MetricsSlider
        title="Average Engagement Rate"
        value={
          getFilter(SOCIAL_PLATFORMS.tiktok, FILTERS.ttAverageEngagementRate) ||
          0
        }
        metrics={tiktokAverageEngagementRate}
        filterType={FILTERS.ttAverageEngagementRate}
      />
    </Box>
  );
};
